<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取FRM绑定信息</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据FRM提供的绑定串码获取需要与本机关联[绑定]的项目/人员组的信息。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public boolean SKFaceGetBindFRMInfo(String BindCode, GetBindFRMInfoCallbackInterface GetBindFRMInfoCallback)
// 获取FRM绑定信息回调接口
public interface GetBindFRMInfoCallbackInterface {
    void GetBindFRMInfoCallback(int Code, String BindFRMInfo);
}</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">（1）BindCode：FRM绑定码</p>
             <p class="doc_main_p">（2）GetBindFRMInfoCallback：获取FRM绑定信息（比如项目名称、人员组名称...）回调接口</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
       <p class="doc_main_p">（1）boolean类型，true表示成功，可处理回调结果；false表示失败（绑定码格式有误），无需处理回调（回调不返回信息）</p>
        <p class="doc_main_p">（2）GetBindFRMInfoCallback(int Code, String BindFRMInfo)：
Code错误码，0：成功，BindFRMInfo为绑定信息；其他：失败，BindFRMInfo为错误信息
BindFRMInfo绑定FRM信息（比如项目名称、人员组名称...），Code非0时为错误信息
</p>
        <h3 class="doc_main_h3">错误码列表</h3>
		<get-frm-bind-code-error-list :propsTableData="errorCodeList"></get-frm-bind-code-error-list>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">boolean flag = skFace.SKFaceGetBindFRMInfo("2sdfasdhw", new GetBindFRMInfoCallbackInterface() {
    @Override
    public void GetBindFRMInfoCallback(int Code, String BindFRMInfo) {
        // TODO 在这里接收FRM绑定信息
    }
});</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import GetFRMBindCodeErrorList from '../../../../components/getFRMBindCodeErrorList';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'get-frm-bind-code-error-list':GetFRMBindCodeErrorList,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Android','视频接口','获取FRM绑定信息'],
				errorCodeList:[
					{"code":"0","msg":"成功"},
					{"code":"10003","msg":"要绑定的人员不存在"},
					{"code":"-500","msg":"网络请求失败"},
				]

			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdklive/voideinitiali/VoideFrmInformation.vue